/**
 * Date-extensions locale Javanese [jv]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('jv', {
    monthNames: ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','Nopember','Desember'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Ags','Sep','Okt','Nop','Des'],
    dayNames: ['Minggu','Senen','Seloso','Rebu','Kemis','Jemuwah','Septu'],
    dayShortNames: ['Min','Sen','Sel','Reb','Kem','Jem','Sep']
});
